import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router-dom';
import { addLocale } from '../misc';

export const REPORTING_PORTAL_PATH = '/reporting-and-analytics';

// The old /black-friday-reports address now lands on the portal and keeps the query string
// (for example ?date=2026-11-27), so bookmarks and shared links keep working.
const LegacyReportsRedirect = ({ locale }) => {
  const { search } = useLocation();
  return (
    <Redirect to={{ pathname: addLocale(locale)(REPORTING_PORTAL_PATH), search }} />
  );
};

LegacyReportsRedirect.propTypes = {
  locale: PropTypes.string.isRequired
};

export default LegacyReportsRedirect;
